import { render } from "./HowToUser.vue?vue&type=template&id=126ed1ee"
import script from "./HowToUser.vue?vue&type=script&lang=js"
export * from "./HowToUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__